import ThemeButton from "components/Buttons/ThemeButton";
import { styled } from "@mui/material";

export const Container = styled("div")<{ scale: number }>`
	width: 370px;
	height: 370px;
	background-color: #fff;
	border-radius: 1rem;
	position: relative;
	overflow: hidden;
	transform: scale(${(props) => props?.scale});
	/* @media (max-width: 345px) {
		width: 95%;
	} */
`;
/* eslint-disable */
export const Header = styled("div")`
	height: 188px;
	width: 100%;
	background-repeat: no-repeat;
	background-position: cover;
	background-size: cover;
	background-image: url(${(props: any) => props["data-image"]});
	position: relative;
`;
/* eslint-enable */
export const Avatar = styled("img")`
	width: 100px;
	object-fit: contain;
	position: absolute;
	bottom: 2rem;
	right: 15%;
`;

export const Body = styled("div")`
	padding: 1rem;
	display: flex;
	justify-content: center;
	align-items: center;
	flex-direction: column;
	gap: 1rem;
	font-family: Baloo;
	color: #333;
`;

export const Title = styled("span")`
	font-family: "Baloo";
	font-size: 25px;
	text-align: center;
`;

export const Button = styled(ThemeButton)`
	//padding: 0.5rem;
	width: 90%;
`;
